import { type Tractor } from '../domain/Tractor'

export type RawTractor = {
  uuid: string
  value: string
  source: string
  carrier: {
    dot_number: string
    mc_number: string
  }
}

export function mapApiToTractors(tractors?: RawTractor[]): Tractor[] {
  return (tractors || []).map(tractor => ({
    tractorNumber: tractor.value,
    tractorNumberSource: tractor.source,
  }))
}
